import React from 'react';
import { injectIntl, FormattedMessage } from 'gatsby-plugin-react-intl'
import {Container, Button, FormControl, Form, Col} from 'react-bootstrap';
import { createDemo } from '../../request';

class DemoTrial extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            email: '',
            honeyPot: null,
            isProcessing: false,
            emailError: false,
            serverError: false,
            success: false
        }
    }

    handleInputChange = event => {
        const target = event.target;
        const value = target.value;

        this.setState({
            email: value
        });
    }

    handleHoneyPotChange = event => {
        const target = event.target;
        const value = target.value;

        this.setState({
            honeyPot: value
        });
    }

    handleSubmit = event => {
        event.preventDefault();
        event.stopPropagation();

        this.setState({
            emailError: false,
            serverError: false,
            isProcessing: true
        });

        if (!this.state.email) {

            this.setState({
                isProcessing: false,
                emailError: true
            });

            this.clearErrors();

        } else if (!this.validateEmail(this.state.email)) {

            this.setState({
                isProcessing: false,
                emailError: true
            });

            this.clearErrors();

        } else {

            if (!this.state.honeyPot) {

                createDemo({email: this.state.email}).then(() => {

                    this.setState({
                        isProcessing: false,
                        email: "",
                        success: true,
                        serverError: false
                    });

                    window.dataLayer.push('event', 'conversion', {'send_to': 'AW-970402719/wCTdCNTc0ZEYEJ_X3M4D'});

                }).catch((e) => {

                    this.setState({
                        isProcessing: false,
                        serverError: true
                    });

                    this.clearErrors();
                });

            } else {

                this.setState({
                    isProcessing: false,
                    serverError: true
                });

                this.clearErrors();
            }

        }
    }

    clearErrors = () => {
        setTimeout(() => {
            this.setState({
                emailError: false,
                serverError: false
            });
        }, 8000);
    }

    validateEmail = email => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    render() {
        return (
            <div className={`demo-trial`}>
                <Container>
                    <div className={`title`}><FormattedMessage id="components.demoTrial.title" /></div>
                    <div className={`text`} dangerouslySetInnerHTML={{ __html: this.props.intl.formatMessage({ id: "components.demoTrial.text" }) }}></div>
                    <div className={`form`}>
                        <Form className={`form-area`} onSubmit={this.handleSubmit}>
                            <Form.Row>
                                <Col lg={8}>
                                    <Form.Label className="form-label"><FormattedMessage id="components.demoTrial.email.label" /></Form.Label>
                                    <FormControl type="text" value={this.state.email} placeholder={this.props.intl.formatMessage({ id: "components.demoTrial.email.label" })} className="form-field" onChange={this.handleInputChange} />
                                    <div style={{position: "absolute", left: "-9999px", overflow: "hidden"}} aria-hidden="true">
                                        <input className="form-field" placeholder={this.props.intl.formatMessage({ id: "components.demoTrial.email.placeholder" })} type="text" onChange={this.handleHoneyPotChange} />
                                    </div>
                                    {this.state.emailError === true && <div className={`form-feedback`}><FormattedMessage id="components.demoTrial.email.error" /></div>}
                                    {this.state.serverError === true && <div className={`form-feedback`}><FormattedMessage id="components.demoTrial.email.serverError" /></div>}
                                    {this.state.success === true && <div className={`form-feedback`}><FormattedMessage id="components.demoTrial.email.success" /></div>}
                                </Col>
                                <Col lg={4}>
                                    <Button className={`button`} variant="dark-blue" type="submit" disabled={this.state.isProcessing}><FormattedMessage id="components.demoTrial.email.button" /></Button>
                                </Col>
                            </Form.Row>
                        </Form>
                    </div>
                </Container>
            </div>
        )
    }
}

export default injectIntl(DemoTrial)
